import {useParams} from 'react-router-dom'
import {OneLineAmoCRM} from './OneLineAmoCRM'
import {AmoCRMLineHeader} from './AmoCRMLineHeader'
import {appsAPI} from '../../../../../../services/AppsService'
import {IAppAmoCRMLine} from '../../../../../../template/partials/modals/create-app/IAppModels'
import {useEffect, useState} from 'react'

const LinesAmoCRM = () => {
  const {appId} = useParams()
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)
  const [allLines, setAllLines] = useState<IAppAmoCRMLine[]>(app?.settings.amocrm.lines!)
  const [mainLine, setMainLine] = useState<IAppAmoCRMLine>()
  const [otherLines, setOtherLines] = useState<IAppAmoCRMLine[]>([])

  useEffect(() => {
    if (app && app.settings.amocrm.lines !== undefined) {
      setAllLines(app.settings.amocrm.lines)
    }
  }, [app])

  useEffect(() => {
    if (allLines) {
      const _mainLine = allLines.find((_line) => _line.line === '')
      setMainLine(_mainLine)
      const _otherLines = allLines.filter((_line) => _line.line !== '')
      const sortedOtherLines = _otherLines.sort((a, b) => a.id!.localeCompare(b.id!))
      setOtherLines(sortedOtherLines)
    }
  }, [allLines])

  return (
    <table className='table align-middle table-row-dashed fs-7 gy-5 dataTable no-footer'>
      <AmoCRMLineHeader />
      <tbody>
        {mainLine && <OneLineAmoCRM line={mainLine!} />}
        {otherLines?.map((line) => (
          <OneLineAmoCRM line={line} key={line.id} />
        ))}
      </tbody>
    </table>
  )
}

export {LinesAmoCRM}
